Ext.ns('mx.comp');

mx.comp.ContactDetailsList = Ext.extend(mx.comp.ListField, {
    valueFieldWidth: 100,
    labels: {
        email: 'E-mail',
        fax: 'Fax',
        mobile: 'Mobile',
        officephone: 'Office num.',
    },
    valueConfig: {
        store: null,
        valueField: 'id',
        displayField: 'name',
        mode: 'local',
        editable: false,
        forceSelection: true,
        triggerAction: 'all',
        resizable: true,
    },
    initComponent: function() {
        this.valueConfig.store = new Ext.data.SimpleStore({
            fields: ['id', 'name', 'vtype', 'regex'],
            data: [
                ['EMAIL', this.labels.email, 'emailAddress'],
                ['FAX', this.labels.fax, null],
                ['MOBILE', this.labels.mobile, null],
                ['OFFICEPHONE', this.labels.officephone, null],
            ],
        });
        mx.comp.ContactDetailsList.superclass.initComponent.apply(this, arguments);
    },
});

Ext.reg('mx-contactdetaillist', mx.comp.ContactDetailsList);
